import api from '../../../services/api'
import type { BruktbilFilters } from '../useBruktbilFilters'
import type { MerkeChip } from '../Kjopere/api'

export interface SelgerRow {
  org_nr: string | null
  org_name: string | null
  postnummer: string | null
  count: number
  avg_bilalder: number | null
  top_merker: MerkeChip[]
  drivstoff_dominant: string | null
  drivstoff_share: number | null
}

export interface SelgereResponse {
  data: SelgerRow[]
  total: number
  page: number
  pages: number
}

interface SelgereParams extends Pick<BruktbilFilters, 'from' | 'to' | 'klasse' | 'varebil' | 'omregistrering'> {
  selgerPostnummer?: string | null
  kjoperPostnummer?: string | null
  groupBy: string
  page?: number
  classification?: string | null // seller org classification filter (#475)
  q?: string | null // name contains / org_nr prefix — Sammenligning picker (#484)
}

export function fetchSelgere(params: SelgereParams): Promise<{ data: SelgereResponse }> {
  return api.get<SelgereResponse>('/bruktbil/selgere', {
    params: {
      from_date: params.from,
      to_date: params.to,
      klasse: params.klasse,
      varebil: params.varebil,
      omregistrering: params.omregistrering || undefined,
      group_by: params.groupBy,
      page: params.page ?? 1,
      page_size: 50,
      classification: params.classification || undefined,
      q: params.q || undefined,
      ...(params.selgerPostnummer ? { selger_postnummer: params.selgerPostnummer.split(',') } : {}),
      ...(params.kjoperPostnummer ? { kjoper_postnummer: params.kjoperPostnummer.split(',') } : {}),
    },
    paramsSerializer: { indexes: null },
  })
}
